module.exports = __webpack_public_path__ + "img/clear.d8356ac3.png";